export enum ScalingType {
    Absolute,
    Related
}
